import React, { useEffect, useState } from 'react';
import { Star, Heart } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import { useEvent } from '../context/EventContext';
import { store } from '../lib/localStore';
import { AudienceResult } from '../components/AudienceResult';

export default function MyNotes() {
  const { t } = useLang();
  const { config } = useEvent();
  const products = config?.products || [];
  const eventId = config?.event?.id;

  const [tasting, setTasting] = useState({});
  const [favourite, setFavourite] = useState(null);

  useEffect(() => {
    if (!eventId) return;
    setTasting(store.getTasting(eventId));
    setFavourite(store.getFavourite(eventId));
  }, [eventId]);

  const favProduct = products.find((p) => p.id === favourite);
  const hasAny = Object.keys(tasting).length > 0;

  return (
    <div data-testid="my-notes-screen">
      <h1 className="font-serif font-bold text-3xl text-[#FDFBF7]">{t('notes_title')}</h1>

      <div className="mt-4 mb-5 bg-gradient-to-b from-[#111A38] to-[#0B132B] border border-[#D4AF37]/25 rounded-2xl p-4">
        <span className="font-mono text-[10px] tracking-widest uppercase text-slate-400">{t('myFavouriteIs')}</span>
        <div className="flex items-center gap-2 mt-1">
          <Heart size={18} className="text-[#E63946]" fill={favProduct ? '#E63946' : 'none'} />
          <span className="font-serif text-lg text-[#E5C158]">{favProduct ? favProduct.name : t('noFavourite')}</span>
        </div>
      </div>

      {!hasAny && <p className="text-sm text-slate-400 py-6 text-center">{t('notes_empty')}</p>}

      <div className="space-y-3">
        {products.map((p) => {
          const d = tasting[p.id] || {};
          const aromas = d.aromas || [];
          const empty = !d.rating && aromas.length === 0 && !d.notes;
          return (
            <div key={p.id} data-testid={`notes-card-${p.order}`} className="bg-[#111A38] border border-[#D4AF37]/20 rounded-xl p-4">
              <div className="flex justify-between items-start gap-2">
                <div>
                  <span className="font-mono text-[10px] text-slate-500">#{p.order}</span>
                  <h3 className="font-serif text-lg text-[#FDFBF7] leading-tight">{p.name}</h3>
                </div>
                <div className="flex gap-0.5 shrink-0">
                  {[1, 2, 3, 4, 5].map((n) => (
                    <Star key={n} size={14} className={d.rating >= n ? 'text-[#D4AF37]' : 'text-slate-700'} fill={d.rating >= n ? '#D4AF37' : 'none'} />
                  ))}
                </div>
              </div>
              {empty && <p className="text-xs text-slate-500 mt-2">{t('noRating')}</p>}
              {aromas.length > 0 && (
                <div className="flex flex-wrap gap-1.5 mt-2">
                  {aromas.map((a) => (
                    <span key={a} className="text-[10px] px-2 py-0.5 rounded-full bg-[#18244D] text-slate-300 border border-[#D4AF37]/20">{t(`aroma_${a}`)}</span>
                  ))}
                </div>
              )}
              {d.notes && <p className="text-sm text-slate-300 mt-2 italic leading-snug">"{d.notes}"</p>}
            </div>
          );
        })}
      </div>

      <div className="mt-6">
        <AudienceResult />
      </div>
    </div>
  );
}
